import React, { useEffect, useState } from 'react';
import { isPushSupported, getNotificationPermission, getCurrentSubscription, enablePushNotifications } from '../push';

const DISMISS_KEY = 'incomail_push_banner_dismissed';

/**
 * Dezenter, wegklickbarer Hinweis, Push-Benachrichtigungen zu aktivieren.
 * Erscheint nur, wenn: der Browser Push unterstützt, noch keine Entscheidung
 * getroffen wurde (Permission = 'default', nicht bereits erlaubt/abgelehnt),
 * noch keine aktive Subscription existiert, und der Nutzer den Hinweis nicht
 * bereits weggeklickt hat (persistiert lokal pro Browser/Gerät).
 */
export default function NotificationBanner() {
  const [visible, setVisible] = useState(false);
  const [enabling, setEnabling] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function check() {
      if (!isPushSupported()) return;
      if (localStorage.getItem(DISMISS_KEY) === '1') return;
      if (getNotificationPermission() !== 'default') return;
      try {
        const sub = await getCurrentSubscription();
        if (!cancelled && !sub) setVisible(true);
      } catch {
        // Stiller Fehlschlag — Banner einfach nicht anzeigen
      }
    }
    check();
    return () => { cancelled = true; };
  }, []);

  const handleEnable = async () => {
    setEnabling(true);
    setError('');
    try {
      await enablePushNotifications();
      setVisible(false);
    } catch (e) {
      setError(e.message || 'Aktivierung fehlgeschlagen.');
    } finally {
      setEnabling(false);
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-blue-50 border-b border-blue-200 px-4 md:px-6 py-3 flex items-center gap-3 flex-wrap">
      <span className="text-blue-500 text-lg flex-shrink-0">🔔</span>
      <div className="flex-1 min-w-[220px]">
        <span className="text-sm font-medium text-blue-800">Benachrichtigungen aktivieren?</span>{' '}
        <span className="text-sm text-blue-700">
          Wir informieren dich dann direkt auf diesem Gerät, wenn neue E-Mails eintreffen.
        </span>
        {error && <div className="text-xs text-red-600 mt-1">{error}</div>}
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button onClick={handleEnable} disabled={enabling}
          className="px-3 py-1.5 bg-blue-600 text-white text-xs rounded-lg hover:bg-blue-700 disabled:opacity-50 whitespace-nowrap">
          {enabling ? 'Aktiviere…' : 'Aktivieren'}
        </button>
        <button onClick={handleDismiss}
          className="px-3 py-1.5 border border-blue-300 text-blue-700 text-xs rounded-lg hover:bg-blue-100 whitespace-nowrap">
          Später
        </button>
      </div>
    </div>
  );
}
